<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <main
      class="scrollable container"
      :style="{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }"
    >
      <PadLockSvg :style="{marginBottom: '30px'}" />
      <h2 :style="{marginBottom: '20px'}">
        Your password has <br />
        been reset!
      </h2>
      <p
        :class="'t16'"
        :style="{marginBottom: '30px'}"
      >
        Qui ex aute ipsum duis. Incididunt adipisicing <br />
        voluptate laborum
      </p>
      <Button
        :title="'Done'"
        :style="{width: '50%'}"
        :onClick="() => $router.push(routes.SIGN_IN)"
      />
    </main>
  </div>
</template>

<script setup>
// vendors
import {routes} from '@/routes';

// hooks
import {useOpacity} from '@/hooks';

// svg
import {PadLockSvg} from '@/assets/svg';

// components
import {Background} from '@/components';
import {Button} from '@/components';

// other
const opacity = useOpacity();
</script>
